// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as AuthActions } from '../../../../auth/duck';
import type { RootState } from '../../../../index';
import AlreadyExistsFacebookAccount from '../component/AlreadyExistsFacebookAccount';

function mapStateToProps(state: RootState) {
  return {
    isAuthing: state.auth.isAuthing,
    authError: state.auth.authError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(AuthActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AlreadyExistsFacebookAccount);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/already-exists-facebook-account/container/AlreadyExistsFacebookAccountContainer.js